export default "__VITE_PUBLIC_ASSET__2a5f93f7__"